import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Card, CardBody, Button, Spinner } from "reactstrap";
import { FaCheckCircle } from "react-icons/fa";

const SuccessScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [confirming, setConfirming] = useState(true);
    const [error, setError] = useState("");
    const [details, setDetails] = useState({
        plan: "",
        renewalDate: "",
        transactionId: ""
    });

    const getQueryParam = (key) => new URLSearchParams(location.search).get(key);

    useEffect(() => {
        const init = async () => {
            const sessionId = getQueryParam("session_id");
            const farmIdFromStorage = sessionStorage.getItem("renewFarmId") || localStorage.getItem("defaultFarmId");
            const userId = localStorage.getItem("loggedInUserId");

            if (!sessionId || !farmIdFromStorage) {
                setError("Missing session or farm information.");
                setConfirming(false);
                return;
            }

            try {
                // Confirm payment/renewal with backend
                const payload = {
                    SessionId: sessionId,
                    FarmId: parseInt(farmIdFromStorage),
                    IsSubscription: false,
                    UserId: userId
                };
                await axios.post("/api/Subscription/UpdateSubscriptionDetailsAfterRenew", payload);

                // Fetch latest subscription details to show on screen
                const subRes = await axios.get("/api/Subscription/GetFarmSubscription", {
                    params: { farmId: parseInt(farmIdFromStorage) }
                });

                const data = subRes?.data || {};
                const renewHistory = data?.renewHistory || data?.RenewHistory || [];
                const latest = Array.isArray(renewHistory) && renewHistory.length > 0 ? renewHistory[0] : null;

                setDetails({
                    plan: (data?.farmType ? `${data.farmType} Annual` : "Premium Annual"),
                    renewalDate: data?.renewalDate || data?.RenewalDate || "-",
                    transactionId: latest?.transactionId || latest?.TransactionId || "-"
                });
            } catch (e) {
                setError(e?.response?.data || e?.message || "Failed to confirm payment.");
            } finally {
                setConfirming(false);
            }
        };
        init();
    }, [location.search]);

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <div className="text-center" style={{ maxWidth: 520, width: "100%" }}>
                <FaCheckCircle size={56} color="#28a745" />
                <h2 className="mt-3" style={{ fontWeight: 800 }}>Subscription Renewed Successfully!</h2>
                <p className="text-muted mt-2">
                    Thank you! Your subscription has been successfully renewed. You can continue enjoying all features without interruption.
                </p>

                <Card className="mt-3" style={{ borderRadius: 12 }}>
                    <CardBody>
                        {confirming ? (
                            <div className="py-3 d-flex justify-content-center align-items-center" style={{ gap: 8 }}>
                                <Spinner size="sm" />
                                <span>Finalizing your renewal...</span>
                            </div>
                        ) : error ? (
                            <div className="py-2 text-danger">{String(error)}</div>
                        ) : (
                            <div className="text-start" style={{ lineHeight: 1.9 }}>
                                <div className="d-flex justify-content-between">
                                    <span>Plan:</span>
                                    <strong>{details.plan}</strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span>Renewal Date:</span>
                                    <strong>{details.renewalDate}</strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span>Transaction ID:</span>
                                    <strong>{details.transactionId}</strong>
                                </div>
                            </div>
                        )}
                    </CardBody>
                </Card>

                <Button
                    color="primary"
                    className="mt-4"
                    style={{ background: "#0d535d", paddingLeft: 24, paddingRight: 24 }}
                    onClick={() => navigate("/farm-subscription")}
                    disabled={confirming}
                >
                    Go to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default SuccessScreen;


